<template>
  <div style="width: 100%" class="price-target">
    <v-container v-if="isLawyer && plan != null">
      <v-row>
        <v-col cols="12" sm="3">
          <v-select :items="planNames"
                    item-text="abbr"
                    item-value="state"
                    v-model="plan.plan_title"
                    :label="language.lang('Services')"
                    :hint="language.lang('Choose the service')"
                    persistent-hint>
          </v-select>
        </v-col>
        <v-col cols="12" sm="3">
          <v-text-field
              :hint="language.lang('In Dollars')"
              persistent-hint
              type="number"
              v-model="plan.plan_price"
              :label="language.lang('Service price')"
          ></v-text-field>
        </v-col>
        <v-col cols="12" sm="3">
          <v-text-field
              persistent-hint
              type="number"
              :hint="language.lang('Percent of retainer amount (eg: 30)')"
              v-model="plan.plan_refund"
              :label="language.lang('Does the service have refund policy?')"
          ></v-text-field>
        </v-col>
        <v-col cols="12" sm="3">
          <v-text-field
              persistent-hint
              type="number"
              :hint="language.lang('Enter number of Installments (eg: 2)')"
              v-model="plan.plan_installments"
              :label="language.lang('How many payment installments?')"
          ></v-text-field>
        </v-col>
        <v-col cols="12" sm="3">
          <v-text-field
              persistent-hint
              type="number"
              :hint="language.lang('Enter number of days (eg: 365)')"
              v-model="plan.plan_time"
              :label="language.lang('Time to submit application')"
          ></v-text-field>
        </v-col>
        <v-col cols="12" sm="6">
          <v-textarea
              v-model="plan.plan_brief"
              :label="language.lang('Additional details')"
          ></v-textarea>
        </v-col>
      </v-row>
      <div :class="!isEN ? 'text-left' : 'text-right'">
        <base-button tag="span" @click="submitPlan"
                     type="default" text-color="white" class="m-1 mt-4">
          {{ language.lang('Save') }}
        </base-button>
        <base-button v-if="plan != null && plan.plan_id != null" tag="span" @click="deletePlan"
                     type="danger" text-color="white" class="m-1 mt-4">
          {{ language.lang('Delete') }}
        </base-button>
        <base-button tag="span" @click="discardPlan"
                     type="secondary" class="m-1 mt-4">
          {{ language.lang('Discard') }}
        </base-button>
      </div>
    </v-container>
    <div v-if="isLawyer" style="width: 100%" class="border-bottom mt-3 mb-3"></div>
    <v-col cols="12" md="3" v-for="(item, index) in plans"
           :key="index" class=" mt-1 mb-1">
      <v-card class="d-flex flex-column"
              style="width: 260Px; padding: 10px; margin-left: auto; margin-right: auto; height: 100%;">
        <h4 style="font-size: 16px" v-if="!oracle.isEmpty(item.plan_title)">{{ search(item.plan_title) }}</h4>
        <div style="width: 100%; height: 1px; background-color: lightgray" class="mt-2 mb-2"></div>
        <h5 v-if="!oracle.isEmpty(item.plan_price)">{{ language.lang('Price: ') }}<span
            class="">{{ item.plan_price + "$" }}</span>
        </h5>
        <h5 v-if="!oracle.isEmpty(item.plan_time)">{{ language.lang('Duration: ') }}<span
            class="">{{ item.plan_time + " " + language.lang('day(s)') }}</span>
        </h5>
        <h5 v-if="!oracle.isEmpty(item.plan_refund)">{{ language.lang('Refund: ') }}<span
            class="">{{ item.plan_refund + " " + language.lang('percent from contract') }}</span>
        </h5>
        <h5 v-if="!oracle.isEmpty(item.plan_installments)">{{ language.lang('Installments: ') }}<span
            class="">{{ item.plan_installments + " " + language.lang('part(s)') }}</span>
        </h5>
        <div class="border-bottom mb-2"></div>
        <h5 v-if="!oracle.isEmpty(item.plan_brief)">{{ language.lang('Details: ') }}<p>{{ item.plan_brief }}</p>
        </h5>
        <base-button class="mt-auto" text-color="white" style="width: 100%" tag="span" @click="requestDocument(item)"
                     type="default">
          {{ language.lang(isLawyer ? 'Edit' : 'Apply') }}
        </base-button>
      </v-card>
    </v-col>
  </div>
</template>
<script>
import oracle from "@/utils/oracle";
import language from "@/utils/language";

export default {
  props: {
    lawyer: Object,
    isLawyer: Boolean
  },
  data: () => ({
    planNames: [
      {abbr: language.lang('ICT'), state: 'ICT'},
      {abbr: language.lang('PNP'), state: 'PNP'},
      {abbr: language.lang('Express Entry (T...)'), state: 'Express Entry (T...)'},
      {abbr: language.lang('Express Entry (CEC)'), state: 'Express Entry (CEC)'},
      {abbr: language.lang('Express Entry (FSW)'), state: 'Express Entry (FSW)'},
      {abbr: language.lang('Business visitor visa'), state: 'Business visitor visa'},
      {abbr: language.lang('Startup visa'), state: 'Startup visa'},
      {abbr: language.lang('Owner operator'), state: 'Owner operator'},
      {abbr: language.lang('Work permit'), state: 'Work permit'},
      {abbr: language.lang('Study permit'), state: 'Study permit'},
      {abbr: language.lang('Judicial review'), state: 'Judicial review'},
      {abbr: language.lang('PGWP'), state: 'PGWP'},
      {abbr: language.lang('Self employed'), state: 'Self employed'},
      {abbr: language.lang('Care giver program'), state: 'Care giver program'},
      {abbr: language.lang('PNP entrepreneurship'), state: 'PNP entrepreneurship'},
      {abbr: language.lang('Spousal sponsorship (PR)'), state: 'Spousal sponsorship (PR)'},
      {
        abbr: language.lang('Parents and grandparents sponsorship'),
        state: 'Parents and grandparents sponsorship'
      },
      {abbr: language.lang('Super Visa'), state: 'Super Visa'},
      {abbr: language.lang('Visitor visa (tourism)'), state: 'Visitor visa (tourism)'},
      {abbr: language.lang('Refugee'), state: 'Refugee'},
    ],
    plans: [],
    plan: {},
    oracle: oracle,
    language: language,
    isEN: oracle.isEN(),
  }), methods: {
    search(item) {
      for (let i = 0; i < this.planNames.length; i++) {
        if (this.planNames[i].state == item) {
          return this.planNames[i].abbr
        }
      }
      return null
    },
    requestDocument(item) {
      if (this.isLawyer) {
        this.plan = item
        return
      }
      oracle.axios('plan/subscribe', {plan_id: item.plan_id}, (res) => {
        oracle.showMessage(language.lang('Your apply request received successfully. please contact your consultant directly for more info.')
            , language.lang('Go to my cases'), (res) => {
              this.$router.push('/profile')
            }, 'checked')
      })
    }, deletePlan(item) {
      this.plan.visibility = false
      oracle.axios('plan/update', this.plan, (res) => {
        this.discardPlan()
        this.fetch()
      })
    }, discardPlan() {
      this.plan = {}
    }, submitPlan(item) {
      this.plan.visibility = true
      oracle.axios(this.plan.plan_id != null ? 'plan/update' : 'plan/create'
          , this.plan, (res) => {
            this.discardPlan()
            this.fetch()
          })
    }, fetch() {
      oracle.axios('plan/getList', {parent_by: this.lawyer.lawyer_id, limit_by: 1000}, (res) => {
        this.plans = res.data
      })
    }
  },
  mounted() {
    this.fetch()
  }
};
</script>
<style>
.price-target {
  display: flex;
  flex-wrap: wrap
}

.price-target h5 {
  font-size: 13px;
  font-weight: bold;
  color: gray;
}

.price-target span {
  font-size: 14px;
  font-weight: bold;
  color: black;
}
</style>
